// extracted by mini-css-extract-plugin
export default {"container_loader":"Loader_container_loader__fjM6Q","loader":"Loader_loader__DwtSp","spin":"Loader_spin__ddwRw"};